import { getAddresses } from '@iheartjane/geolocation';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { DeepReadonly } from 'ts-essentials';

import { getGoogleMaps } from '@jane/shared-ecomm/util';

import type { AppDispatch, AppState } from '../redux';

type Address = { label: string; value: string };
type AddressAutocompleteState = DeepReadonly<{
  addresses: Address[];
  chosenAddress: Address | string | null;
}>;

const getInitialState = (): AddressAutocompleteState => ({
  addresses: [],
  chosenAddress: null,
});

const addressAutocompleteSlice = createSlice({
  name: 'addressAutocomplete',
  initialState: getInitialState(),
  reducers: {
    setAddresses: (state, action: PayloadAction<Address[]>) => {
      state.addresses = action.payload;
    },
    resetAddressAutocomplete: () => {
      return getInitialState();
    },
  },
});

export const { reducer: addressAutocompleteReducer } = addressAutocompleteSlice;
const { setAddresses, resetAddressAutocomplete } =
  addressAutocompleteSlice.actions;
export { setAddresses };
export const selectAddressAutocomplete = (state: AppState) =>
  state.addressAutocomplete;

export const handleAddressAutocompleteChange =
  (value: string | null, countries?: string[]) =>
  async (dispatch: AppDispatch) => {
    if (!value) {
      dispatch(resetAddressAutocomplete());
      return;
    }

    const result = await getAddresses({
      countries,
      input: value,
      loader: getGoogleMaps,
    });
    dispatch(setAddresses(result));
  };
